import ResortsLandingView from './ResortsLandingView';

export default ResortsLandingView;
